import actionTypes from '../actions/actionTypes'

const defaultState = {
	owner: {
		lessons: {
			page: -1,
			more: true,
			searched: false,
			entities: [],
			drag_init_index: 0,
			drag_end_index: 0,
			canHover: true,
			isDragging: false,
		},
		data: {
			bio: '',
			bio_to_submit: '',
			edit_bio: false,
			downloads: '',
			ownerId: 0,
		},
	},
	visitor: {
		lessons: {
			page: -1,
			more: true,
			searched: false,
			entities: [],
		},
		data: {
			bio: '',
			owner_profile_picture: '',
			owner_name: '',
			owner_school: '',
			owner_account_date: '',
			grades: [],
			subjects: [],
			downloads: '',
			ownerId: 0,
			owner_follow_data: {
				data: {
					entityUID: 0,
					isFollowing: false,
					ownerFollowers: [],
					ownerFollowersCount: '',
				},
			},
		},
	},
}

function populateAdminData(state, action) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.data = action.data
	return newState
}

function populateVisitorOwnerId(state, action) {
	const newState = {...state}
	newState.visitor = {...state.visitor}
	newState.visitor.data = {...state.visitor.data}
	newState.visitor.data.ownerId = action.ownerId
	return newState
}

function updateLessons(viewer, action) {
	const newViewer = {...viewer}
	newViewer.lessons = {...viewer.lessons}
	if (action.full_page) {
		newViewer.lessons.page += 1
	}
	if (newViewer.lessons.page === 0 && action.full_page) {
		newViewer.lessons.entities = action.entities.map(item => item.data.entityUID)
	} else {
		newViewer.lessons.entities = [...viewer.lessons.entities, ...action.entities.map(item => item.data.entityUID)]
	}
	newViewer.lessons.more = action.more
	newViewer.lessons.searched = true
	newViewer.lessons.count = action.count
	return newViewer
}

function updateLessonsList(state, action) {
	const newState = {...state}
	newState.owner = updateLessons(state.owner, action)
	return newState
}

function updateVisitorLessonsList(state, action) {
	const newState = {...state}
	newState.visitor = updateLessons(state.visitor, action)
	return newState
}

function loadNextPage(state) {
	return state
}

function resetLessonsList(state) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.lessons = {...state.owner.lessons}
	newState.owner.lessons.page = -1
	return newState
}

function removeLessonFromList(state, action) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.lessons = {...state.owner.lessons}

	const index = newState.owner.lessons.entities.indexOf(action.entityUID)
	if (index !== -1) {
		newState.owner.lessons.entities = [...state.owner.lessons.entities.slice(0, index), ...state.owner.lessons.entities.slice(index + 1)]
	}

	return newState
}

function populateVisitorData(state, action) {
	const newState = {...state}
	newState.visitor = {...state.visitor}
	newState.visitor.data = action.data
	newState.visitor.data.ownerId = action.ownerId
	return newState
}

function sortHoverLesson(state, action) {
	const sourceId = action.sourceUID
	const targetId = action.targetUID
	const sourceIndex = state.owner.lessons.entities.findIndex(lessonId => lessonId === sourceId)
	const dropIndex = state.owner.lessons.entities.findIndex(lessonId => lessonId === targetId)
	// console.log('sourceId: ', sourceId)
	// console.log('targetId: ', targetId)
	if (dropIndex === state.owner.lessons.drag_end_index || !state.owner.lessons.canHover) {
		return state
	} else {
		const newState = {...state}
		newState.owner = {...state.owner}
		newState.owner.lessons = {...state.owner.lessons}
		const entities = [...state.owner.lessons.entities]
		newState.owner.lessons.drag_end_index = dropIndex
		entities.splice(sourceIndex, 1)
		entities.splice(dropIndex, 0, sourceId)

		newState.owner.lessons.entities = entities
		return newState
	}
}

function allowHover(state) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.lessons = {...state.owner.lessons}
	newState.owner.lessons.canHover = true
	return newState
}

function startSort(state, action) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.lessons = {...state.owner.lessons}
	const sourceId = action.entityUID
	const sourceIndex = state.owner.lessons.entities.findIndex(lessonId => lessonId === sourceId)
	newState.owner.lessons.drag_init_index = sourceIndex
	newState.owner.lessons.isDragging = true
	newState.owner.lessons.drag_end_index = sourceIndex
	newState.owner.lessons.canHover = false
	return newState
}

function endSort(state) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.lessons = {...state.owner.lessons}
	newState.owner.lessons.isDragging = false
	return newState
}

function updateBio(state) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.data = {...state.owner.data}
	newState.owner.data.bio = state.owner.data.bio_to_submit
	newState.owner.data.edit_bio = false
	newState.owner.data.bio_to_submit = ''
	return newState
}

function followOwner(state, follow) {
	const newState = {...state}
	newState.visitor = {...state.visitor}
	newState.visitor.data = {...state.visitor.data}
	newState.visitor.data.owner_follow_data = {...newState.visitor.data.owner_follow_data}
	newState.visitor.data.owner_follow_data.data = {...newState.visitor.data.owner_follow_data.data}
	newState.visitor.data.owner_follow_data.data.isFollowing = follow
	if (follow)
		newState.visitor.data.owner_follow_data.data.ownerFollowersCount++
	else
		newState.visitor.data.owner_follow_data.data.ownerFollowersCount--
	return newState
}

function initializeBioForm(state) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.data = {...state.owner.data}
	newState.owner.data.edit_bio = true
	newState.owner.data.bio_to_submit = state.owner.data.bio
	return newState
}

function closeBioForm(state) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.data = {...state.owner.data}
	newState.owner.data.edit_bio = false
	return newState
}

function bioFormChange(state, action) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.data = {...state.owner.data}
	newState.owner.data.bio_to_submit = action.value
	return newState
}

function incrementLessonDownloads(state) {
	const newState = {...state}
	newState.visitor = {...state.visitor}
	newState.visitor.data = {...state.visitor.data}
	newState.visitor.data.downloads += 1
	return newState
}

function finalizeStoreFront(state) {
	const newState = {...state}
	newState.owner = {...state.owner}
	newState.owner.data = {...state.owner.data}
	newState.owner.data.ownerId = 0
	return newState
}

const storeFrontReducer = (state = defaultState, action) => {

	switch (action.type) {
		case actionTypes.STOREFRONT_OWNER_DATA_FETCHED:
			return populateAdminData(state, action)
		case actionTypes.STOREFRONT_VISITOR_INITIALIZE:
			return populateVisitorOwnerId(state, action)
		case actionTypes.STOREFRONT_OWNER_LESSONS_FETCHED:
			return updateLessonsList(state, action)
		case actionTypes.STOREFRONT_OWNER_LOAD_NEXT_PAGE:
			return loadNextPage(state, action)
		case actionTypes.STOREFRONT_LESSONS_PICKER_ADD_SUCCESS:
			return resetLessonsList(state, action)
		case actionTypes.STOREFRONT_REMOVE_LESSON_CONFIRMED:
			return removeLessonFromList(state, action)
		case actionTypes.STOREFRONT_VISITOR_DATA_FETCHED:
			return populateVisitorData(state, action)
		case actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER_SUCCESS:
			return followOwner(state, true)
		case actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER_SUCCESS:
			return followOwner(state, false)
		case actionTypes.STOREFRONT_VISITOR_LESSONS_FETCHED:
			return updateVisitorLessonsList(state, action)
		case actionTypes.STOREFRONT_OWNER_SORT_HOVER_LESSON:
			return sortHoverLesson(state, action)
		case actionTypes.STOREFRONT_OWNER_SORT_START:
			return startSort(state, action)
		case actionTypes.STOREFRONT_OWNER_ALLOW_HOVER:
			return allowHover(state)
		case actionTypes.STOREFRONT_OWNER_SORT_LESSONS_RELEASE:
			return endSort(state)
		case actionTypes.STOREFRONT_OWNER_BIO_SUCCESS:
			return updateBio(state)
		case actionTypes.STOREFRONT_OWNER_INITIALIZE_BIO_FORM:
			return initializeBioForm(state)
		case actionTypes.STOREFRONT_OWNER_CLOSE_BIO_FORM:
			return closeBioForm(state)
		case actionTypes.STOREFRONT_OWNER_BIO_FORM_CHANGE:
			return bioFormChange(state, action)
		case actionTypes.STOREFRONT_VISITOR_ADD_LESSON_TO_MY_LIBRARY_SUCCESS:
			return incrementLessonDownloads(state)
		case actionTypes.STOREFRONT_FINALIZE:
			return finalizeStoreFront(state)
		default:
			return state
	}
}

export default storeFrontReducer
